<template>
  <PlaceholderPantalla
    titulo="Catálogo de Productos de Impresión"
    subtitulo="Gestión completa del catálogo de productos y servicios de impresión"
    descripcion="En esta pantalla gestionarás todos los productos de impresión que ofreces: tarjetas de presentación, volantes, lonas, banners, stickers, etc. Podrás configurar especificaciones técnicas (tamaños, acabados), calcular costos automáticos basados en insumos, definir precios de venta, agregar fotos de muestra, y categorizar productos."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../../Finanzas/PlaceholderPantalla.vue'

const funcionalidades = [
  'Crear y editar productos de impresión con nombre, descripción y foto',
  'Categorizar productos (Tarjetas, Volantes, Lonas, Vinilos, Stickers, etc.)',
  'Definir especificaciones técnicas: tamaños estándar y personalizados',
  'Configurar acabados disponibles (laminado, barniz, corte, etc.)',
  'Definir insumos necesarios: tipo de papel/material, tintas, cantidad',
  'Cálculo automático del costo basado en insumos y consumibles',
  'Establecer precio de venta y ver margen de utilidad en tiempo real',
  'Configurar precios por escala (descuentos por volumen)',
  'Activar/desactivar productos según disponibilidad',
  'Asignar código SKU o código interno',
  'Tiempo estimado de producción',
  'Importar/exportar catálogo completo',
  'Historial de cambios de precios',
  'Análisis de popularidad (productos más solicitados)',
  'Duplicar productos para crear variantes rápidamente'
]

const datosManejados = [
  'Nombre del producto',
  'Descripción detallada',
  'Categoría (Tarjetas, Volantes, Lonas, Vinilos, Stickers, etc.)',
  'Foto/mockup del producto',
  'Tamaños disponibles (carta, media carta, personalizados)',
  'Materiales/papeles compatibles',
  'Acabados disponibles (laminado, barniz, corte especial)',
  'Insumos requeridos por unidad (papel, tintas, cantidad)',
  'Costo de producción calculado automáticamente',
  'Precio de venta base',
  'Tabla de precios por volumen',
  'Margen de utilidad (%)',
  'Código SKU / Código interno',
  'Tiempo de producción estimado',
  'Estado (Activo, Inactivo)',
  'Popularidad y estadísticas de venta'
]
</script>
